export const HEADLINE_MAX = 120;

export const headlineErrorOf = (code, term) => {
  const phrase = term ? `\u201c${term}\u201d` : "that phrase";
  if (code === "fairHousing") return `Reword ${phrase}. It could read as a preference under fair housing\u00a0law.`;
  if (code === "bannedPhrase") return `Reword ${phrase}. Gitcha pages do not use that\u00a0phrase.`;
  if (code === "tooLong") return `Keep the headline under ${HEADLINE_MAX}\u00a0characters.`;
  if (code === "hasEmail" || code === "hasLink" || code === "hasPhone")
    return "Take the contact details out of the headline. Visitors reach your agents through each Buyer\u00a0Want\u2011Listing.";
  return "Check the headline and try\u00a0again.";
};

export const isShowcaseOn = (showcase) => {
  if (!showcase) return false;
  if (showcase.comped || showcase.status === "active") return true;
  const grace = showcase.billing?.graceUntil;
  return showcase.status === "past_due" && Boolean(grace) && new Date(grace).getTime() > Date.now();
};

export const ageOf = (createdAt) => {
  const time = new Date(createdAt || 0).getTime();
  if (!time) return "";
  const days = Math.floor((Date.now() - time) / 86400000);
  if (days <= 0) return "Today";
  if (days === 1) return "1 day ago";
  if (days < 60) return `${days} days ago`;
  return `${Math.floor(days / 30)} months ago`;
};
